exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "iframe[data-v-68386ce4] {\n  width: 100%;\n  min-height: 481px;\n}", ""]);

// exports
